var _module_exports = "<div class=\"tab-pane\"\n     ng-if=\"!$ctrl.onlyInitWhenShown || $ctrl.selected\"\n     ng-show=\"$ctrl.selected\"\n     ng-transclude>\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/common/ui/tabby/tabbyTab.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;